import http from 'conversations-http/clients/http';
import { registerQuery } from 'data-fetching-client';
export const CONTENT_ASSISTANCE_SETTINGS_QUERY_NAME = 'contentAssistanceSettings';
export const CONTENT_ASSISTANCE_SETTINGS_QUERY = registerQuery({
  fieldName: CONTENT_ASSISTANCE_SETTINGS_QUERY_NAME,
  fetcher() {
    return http.get(`/content-assistance/v1/settings`);
  }
});